/**
 * Poseedores API
 * Poseedores API.
 *
 * The version of the OpenAPI document: 1.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PoseedorReferenceModel { 
    id?: number;
    razonSocial?: string;
    tipoDocumento?: string;
    denominacionCentro?: string;
    codigoDocumento?: string;
    centro?: string;
    nima?: string;
    iban?: string;
}

